import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { resetJsonLd } from '../../actions/JsonLdActions';
import { baseJsonLdData } from '../../define/consts/jsonld';
import { propStr } from '../../helpers/custom-prop-types';
const JsonLdComponent = (props) => {
    const { pathname } = props;
    const dispatch = useDispatch();
    const jsonLd = useSelector((state) => state.jsonLd);
    useEffect(() => () => {
        // pathname 変更時に初期化
        dispatch(resetJsonLd());
    }, [dispatch, pathname]);
    const jsonLdItems = useMemo(() => Object.entries(jsonLd)
        .filter(([_key, value]) => value.isShow)
        .map(([key, value]) => ({
        data: JSON.stringify(Object.assign(Object.assign({}, baseJsonLdData), value.data), null, 2),
        key,
    })), [jsonLd]);
    if (!jsonLdItems.length) {
        return null;
    }
    return (_jsx(Helmet, { children: jsonLdItems.map(({ data, key }) => (_jsx("script", Object.assign({ type: 'application/ld+json' }, { children: data }), key))) }));
};
JsonLdComponent.propTypes = {
    pathname: propStr().isRequired,
};
export default JsonLdComponent;
